"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../../hooks");
const Image_1 = require("../Image");
function Logo(props) {
    const { logo } = hooks_1.useTheme();
    return jsx_runtime_1.jsx(Image_1.Image, Object.assign({ src: logo, alt: "Logo" }, props), void 0);
}
exports.Logo = Logo;
//# sourceMappingURL=index.js.map